import React, { useEffect, useState } from 'react';
import './TrackHoverTip.css';

/** Delay before showing the floating tip (native title is ~500–1000ms). */
export const TRACK_HOVER_DELAY_MS = 80;

/**
 * Fast floating tooltip for Production / Losses track hover.
 * @param {{ text?: string|null, x?: number, y?: number }} props
 */
export default function TrackHoverTip({ text, x = 0, y = 0 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!text) {
      setVisible(false);
      return undefined;
    }
    const id = window.setTimeout(() => setVisible(true), TRACK_HOVER_DELAY_MS);
    return () => window.clearTimeout(id);
  }, [text, x, y]);

  if (!text || !visible) {
    return <div className="track-hover-tip" hidden data-testid="track-hover-tip" />;
  }

  const left = Math.min(Math.max(8, x + 12), window.innerWidth - 16);
  const top = Math.min(Math.max(8, y + 14), window.innerHeight - 16);

  return (
    <div
      className="track-hover-tip"
      data-testid="track-hover-tip"
      style={{ left: `${left}px`, top: `${top}px` }}
      role="tooltip"
    >
      {text}
    </div>
  );
}
